import { toastr } from 'react-redux-toastr';
import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import addMutation from './addMutation.graphql';
import updateMutation from './updateMutation.graphql';
import updateStatusMutation from './updateStatusMutation.graphql';

export function manageLocation(locationName, coordinates, description, isActive, id, restrictDropOff) {
    return async (dispatch, getState, { client }) => {
        dispatch(setLoaderStart('ManageLocation'));

        const mutation = id ? updateMutation : addMutation;

        const { data } = await client.mutate({
            mutation,
            variables: { id, locationName, coordinates, description, isActive, restrictDropOff },
        });

        dispatch(setLoaderComplete('ManageLocation'));

        if (id) {
            if (data && data.updateLocation && data.updateLocation.status === 200) {
                toastr.success('Success!', 'Location has been updated successfully.');
                history.push('/siteadmin/location');
            } else {
                const msg = data && data.updateLocation && data.updateLocation.errorMessage;
                toastr.error('Error!', msg || 'Something went wrong. Please try again.');
            }
        } else {
            if (data && data.addLocation && data.addLocation.status === 200) {
                toastr.success('Success!', 'Location has been added successfully.');
                history.push('/siteadmin/location');
            } else {
                const msg = data && data.addLocation && data.addLocation.errorMessage;
                toastr.error('Error!', msg || 'Something went wrong. Please try again.');
            }
        }
    };
}

export function updateLocationStatus(id, isActive) {
    return async (dispatch, getState, { client }) => {
        const { data } = await client.mutate({
            mutation: updateStatusMutation,
            variables: { id, isActive },
        });

        if (data && data.updateLocationStatus && data.updateLocationStatus.status === 200) {
            toastr.success('Success!', 'Location status has been updated.');
            return { status: 200 };
        } else {
            const msg = data && data.updateLocationStatus && data.updateLocationStatus.errorMessage;
            toastr.error('Error!', msg || 'Something went wrong.');
            return { status: 400 };
        }
    };
}
